import { RawProductInfo } from "../../../../Models/Basket/Product";
import { ProductOption } from "../../../../Models/Basket/ProductOption";
import { RawProductFromWebsite } from "../../../../Models/ProductsCatalog/RawProduct";
import { RawProductOptionFromWebsite } from "../../../../Models/ProductsCatalog/RawProductOption";

export interface ProductWithOption
{
    ProductInfo: RawProductInfo;
    ProductOption: ProductOption;
}


export class WebsiteProductConverter
{
    static ToBasketProduct(product: RawProductFromWebsite, option: RawProductOptionFromWebsite): ProductWithOption
    {
        const productInfo = this.ToBasketProductInfo(product);
        const optionInfo = this.ToBasketProductOption(option);
        const output = {
            ProductInfo: productInfo,
            ProductOption: optionInfo,
        };
        return output;
    }
    public static ToBasketProductInfo(product?: RawProductFromWebsite): RawProductInfo
    {
        if (!product)
            return ({
                Origin: "",
                Id: "",
                Name: "",
                Link: "",
                Category: "",
                Picture: "",
                Prices: "",
                Tutorial: "",
            });

        return {
            Id: product?.Id || "",
            Origin: "website",
            Name: product?.BasketName || "",
            Link: product?.Url || "",
            Category: product?.CategoryId || "",
            Picture: product?.Images[0]?.MiniUrl || "",
            Prices: product?.RentPrices.map(x => `${x.Days} dni: ${x.Value} zł`).join("\n") || "",
            Tutorial: product?.TutorialLink || "",
        };
    }

    public static ToBasketProductOption(option?: RawProductOptionFromWebsite): ProductOption
    {
        if (!option)
            return ({
                Id: "",
                Name: "",
            });

        return ({
            Id: option?.Url || "",
            Name: option?.Label || "",
        });
    }
}
